module.exports = __webpack_public_path__ + "static/img/recommend.cf54347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recommend.png
// module id = QKfM
// module chunks = 1